
import { Component, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { cloneDeep } from 'lodash'
import { selectSocialInfo, defaultSocialData, insertSocialInfo, updateSocialInfo, deleteSocialInfo } from '@/api/social'
import { IJobSocialData } from '@/api/types'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson } from '@/utils'
import Pagination from '@/components/Pagination/index.vue'

const calendarTypeOptions = [
  { key: 'CN', displayName: 'China' },
  { key: 'US', displayName: 'USA' },
  { key: 'JP', displayName: 'Japan' },
  { key: 'EU', displayName: 'Eurozone' }
]

// arr to obj, such as { CN : "China", US : "USA" }
const calendarTypeKeyValue = calendarTypeOptions.reduce((acc: { [key: string]: string }, cur) => {
  acc[cur.key] = cur.displayName
  return acc
}, {}) as { [key: string]: string }

@Component({
  name: 'ComplexTable',
  components: {
    Pagination
  },
  filters: {
    typeFilter: (type: string) => {
      return calendarTypeKeyValue[type]
    }
  }
})
export default class extends Vue {
  private tableKey = 0
  private list: IJobSocialData[] = []
  private total = 0
  private listLoading = true
  private listQuery = {
    page: 1,
    limit: 20,
    importance: undefined,
    title: undefined,
    type: undefined,
    sort: '+id'
  }

  private importanceOptions = [1, 2, 3]
  private calendarTypeOptions = calendarTypeOptions
  private sortOptions = [
    { label: 'ID Ascending', key: '+id' },
    { label: 'ID Descending', key: '-id' }
  ]

  private cityOptions = ['杭州', '深圳', '杭州、深圳']
  private jobTypeOptions = ['软件开发', '硬件测试', '产品经理', '产品设计', '运营', '客服', '商务', '人事']
  private showReviewer = false
  private dialogFormVisible = false
  private dialogStatus = ''
  private textMap = {
    update: 'Edit',
    create: 'Create'
  }

  private dialogPageviewsVisible = false
  private pageviewsData = []
  private rules = {
    jobType: [{ required: true, message: '不能为空', trigger: 'change' }],
    jobTitle: [{ required: true, message: '不能为空', trigger: 'change' }],
    jobDesc: [{ required: true, message: '不能为空', trigger: 'change' }],
    jobDemand: [{ required: true, message: '不能为空', trigger: 'change' }],
    city: [{ required: true, message: '不能为空', trigger: 'change' }],
    jobTime: [{ required: true, message: '不能为空', trigger: 'change' }],
    salary: [{ required: true, message: '不能为空', trigger: 'change' }]
  }

  private downloadLoading = false
  private tempJobData = defaultSocialData

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    const { data } = await selectSocialInfo(this.listQuery)
    this.list = data.items
    this.total = data.total
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false
    }, 0.5 * 1000)
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getList()
  }

  private handleModifyStatus(row: any, status: string) {
    this.$message({
      message: '操作成功',
      type: 'success'
    })
    row.status = status
  }

  private sortChange(data: any) {
    const { prop, order } = data
    if (prop === 'id') {
      this.sortByID(order)
    }
  }

  private sortByID(order: string) {
    if (order === 'ascending') {
      this.listQuery.sort = '+id'
    } else {
      this.listQuery.sort = '-id'
    }
    this.handleFilter()
  }

  private getSortClass(key: string) {
    const sort = this.listQuery.sort
    return sort === `+${key}` ? 'ascending' : 'descending'
  }

  private resettempJobData() {
    this.tempJobData = cloneDeep(defaultSocialData)
  }

  private handleCreate() {
    this.resettempJobData()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private createData() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const jobData = this.tempJobData
        const { data } = await insertSocialInfo(jobData)
        this.list.unshift(data.social)
        this.dialogFormVisible = false
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        })
        location.reload()
      }
    })
  }

  private handleUpdate(row: any) {
    this.tempJobData = Object.assign({}, row)
    console.info(this.tempJobData)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate()
    })
  }

  private updateData() {
    (this.$refs.dataForm as Form).validate(async(valid) => {
      if (valid) {
        const tempData = Object.assign({}, this.tempJobData)
        const { data } = await updateSocialInfo(tempData.id, tempData)
        const index = this.list.findIndex(v => v.id === data.social.id)
        this.list.splice(index, 1, data.social)
        this.dialogFormVisible = false
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        })
      }
    })
  }

  private handleDelete(row: any, index: number) {
    this.$confirm('将完全删除此条记录，不可恢复?', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        deleteSocialInfo(row.id)
        this.list.splice(index, 1)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  }

  private async handleGetPageviews(pageviews: string) {
    console.info()
    // const { data } = await getPageviews({ pageviews })
    // this.pageviewsData = data.pageviews
    // this.dialogPageviewsVisible = true
  }

  private handleDownload() {
    this.downloadLoading = true
    const tHeader = ['timestamp', 'title', 'type', 'importance', 'status']
    const filterVal = ['timestamp', 'title', 'type', 'importance', 'status']
    const data = formatJson(filterVal, this.list)
    exportJson2Excel(tHeader, data, 'table-list')
    this.downloadLoading = false
  }
}
